import React from 'react';
import clsx from 'clsx';
import { Check } from '@td-client-frontend/icons';

export enum FlagValue {
  TRUE = 'Y',
  FALSE = 'N'
}

interface ToggleProps {
  name: string;
  onChange: (v: any) => void;
  disabled?: boolean;
}

interface ToggleFlag extends ToggleProps {
  value?: FlagValue;
  invert?: boolean;
}

interface ToggleBool extends ToggleProps {
  value?: boolean;
}

export const Toggle: React.FC<ToggleBool> = ({ name, onChange, value = false, disabled = false }) => {
  const handleChange = () => onChange(!value);

  return (
    <label
      className={clsx(
        'w-16 p-1 flex justify-between border-1 rounded-2xl',
        value
          ? disabled
            ? 'border-gray-default bg-transparent'
            : 'bg-green-70 border-transparent'
          : 'border-gray-default',
        disabled && 'bg-gray-15 opacity-75'
      )}
      htmlFor={`Toggle-${name}`}
      data-testid={`Toggle-${name}`}
    >
      <input
        id={`Toggle-${name}`}
        type='checkbox'
        checked={value}
        name={name}
        className='hidden'
        onChange={handleChange}
        disabled={disabled}
      />
      {value && <Check className='ml-1 w-4' color={disabled ? '#9a9fa8' : '#2C632F'} data-testid='check-icon' />}
      <span
        className={clsx(
          'h-6 w-6 block rounded-full',
          value ? 'bg-white' : 'bg-gray-default float-left',
          value && disabled && 'bg-gray-default'
        )}
      />
    </label>
  );
};

export const ToggleFlag: React.FC<ToggleFlag> = ({
  name,
  onChange,
  value = FlagValue.FALSE,
  invert = false,
  ...props
}) => {
  const handleChange = (value: boolean) => {
    const invertedValue = invert ? !value : value;
    onChange(invertedValue ? FlagValue.TRUE : FlagValue.FALSE);
  };

  const booleanValue = value === FlagValue.TRUE && true;

  return <Toggle name={name} value={invert ? !booleanValue : booleanValue} onChange={handleChange} {...props} />;
};
